module.exports = __webpack_public_path__ + "static/macbook-e9872db3ebc5a2368951472dacba0720.png";